export default function(pool, fileName) {
  const len = pool.length;
  for(let i = 0; i < len; i++) {
    if(fileName === pool[i]) return i;
  }
  return 0;
}


// WEBPACK FOOTER //
// ./src/commonJS/getSort.js